/**
 * FikoKaplama — Yüzey İşlem/Kaplama Maliyeti motoru
 * Yüzey alanı (dm²) veya ağırlık (kg) × birim fiyat + min ücret. İşlem tipine göre.
 */

export interface KaplamaTip { ad: string; birim: 'dm2' | 'kg'; fiyat: number; min: number; }

/** İşlem tipleri (TR piyasa yaklaşık). Düzenlenebilir. */
export const KAPLAMA_TIPLERI: KaplamaTip[] = [
  { ad: 'Toz Boya',          birim: 'dm2', fiyat: 6,  min: 60 },
  { ad: 'Eloksal (Anodize)', birim: 'dm2', fiyat: 8,  min: 80 },
  { ad: 'Krom Kaplama',      birim: 'dm2', fiyat: 15, min: 120 },
  { ad: 'Kumlama',           birim: 'dm2', fiyat: 3,  min: 40 },
  { ad: 'Sıcak Daldırma Galvaniz', birim: 'kg', fiyat: 25, min: 50 },
  { ad: 'Isıl İşlem (Sertleştirme)', birim: 'kg', fiyat: 18, min: 100 },
];

export interface KaplamaSonuc { miktar: number; birim: string; hamMaliyet: number; maliyet: number; minUygulandi: boolean; toplam: number; }

/** alanDm2 / agirlikKg + tip + adet → maliyet (min ücret korunur). */
export function kaplamaHesapla(tip: KaplamaTip, alanDm2: number, agirlikKg: number, adet: number): KaplamaSonuc {
  const ad = Math.max(1, adet || 1);
  const miktar = tip.birim === 'kg' ? agirlikKg : alanDm2;
  const ham = miktar * tip.fiyat;
  const maliyet = Math.max(ham, tip.min);
  return { miktar, birim: tip.birim, hamMaliyet: ham, maliyet, minUygulandi: ham < tip.min, toplam: maliyet * ad };
}
